// Sign-out and update safety ask whether this page still holds voice work
// (account-change recording plan rev 4.1, section 5.2). The answer comes from
// voice-capture custody: the fence is held while any capture record exists,
// and only that record's own completion removes it, so an old clean-up can
// never clear a newer capture's hold. Without custody loaded there is no
// voice work on this page.
let workSource: (() => boolean) | null = null;

export function setVoiceWorkSource(source: () => boolean): void {
  workSource = source;
}

export function hasActiveVoiceCaptureWork(): boolean {
  try {
    return workSource?.() ?? false;
  } catch {
    // Fail closed: an unreadable custody state still holds the fence.
    return true;
  }
}
